var version = '4.94.0';

export { version as default };
